
/**
 * Geo-Fence Configurations
 * The API allows users to create, delete, and get status of Geo-fence configurations. Geo-fence configurations define a virtual two-dimensional fence. This fence can then be used to alert users when an asset enters or exits a fence boundary. You can also define a speed limit within the fence, and the telematics device will notify the back office when the speed limit is exceeded. 
 *
 * OpenAPI spec version: 0.1.12
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * The fence configuration type.
 * @export
 * @enum {string}
 */
 export enum ConfigType {
    GeoFence = 'geoFence',
    SpeedFence = 'speedFence'
}

